import { adminHttpClient } from '../../commons/adminHttpClient'

export type BulkEmployeesItem = {
  firstName: string
  lastName: string
  workEmail: string
  receiveSms: boolean
  stateOfResidenceId: string
  workPhone: string
  hireDate: string
  employmentStatus: number
  productClassId: string
  birthday: string
  familyStatusId: number
  zipCode: string
  notificationDate: string
}
export interface AddBulkEmployeesRequest {
  productId: number
  companyId: string
  items: BulkEmployeesItem[]
}
const postAddBulkEmployees = (request: AddBulkEmployeesRequest): Promise<any> => {
  return adminHttpClient.post(`Companies/AddBulkEmployees`, request)
}

export default postAddBulkEmployees
